/**
 * Доступность действий над треком — ЕДИНОЕ место, где фронт решает, показывать
 * ли кнопку/пункт меню/форму действия.
 *
 * Источник истины — контракт бэка `available_actions` (см.
 * `domain/constants/audio_actions.py`). С появлением провайдера трека (`provider`)
 * в контракт вошли и `voice_persona` с `release`, которые раньше фронт решал
 * сам: у трека, сгенерированного запасным провайдером, их нет, как нет и
 * минуса/WAV/продления/замены части/караоке.
 *
 * Поле `provider` — ещё и маркер версии контракта. Пока бэкенд не выкачен, его в
 * ответах нет, а в `available_actions` нет новых ключей — и это НЕ запрет:
 * без `provider` ключи `voice_persona`/`release` решает прежняя локальная логика
 * вызывающего, остальные — как раньше.
 *
 * Модуль чистый (без React и сети) — его гоняют юнит-тесты, см.
 * trackActionAvailability.test.ts.
 */
/**
 * Ключи, которых старый бэкенд (до поля `provider`) в `available_actions` не
 * отдавал: их отсутствие в списке без `provider` ничего не значит.
 */
const ACTIONS_UNKNOWN_TO_LEGACY_BACKEND = new Set([
    "voice_persona",
    "release",
]);
/** Трек сгенерирован основным провайдером; нет поля — считаем, что да. */
export function isSunoTrack(audio) {
    return (audio?.provider ?? "suno") === "suno";
}
/**
 * Разрешено ли действие контрактом бэка.
 *
 *  - есть и `provider`, и `available_actions` → действие доступно ⇔ ключ в списке;
 *  - `provider` нет (старый бэкенд): для `voice_persona`/`release` контракт
 *    ничего не говорит → `true`; для остальных — по списку, если он есть, иначе
 *    `true`.
 *
 * `true` значит «контракт не запрещает»: прежние локальные условия (владелец,
 * готовое аудио, тип строки) вызывающий проверяет сам и объединяет через `&&`.
 * Поэтому без `provider` поведение ровно прежнее.
 */
export function isActionAvailable(audio, action) {
    const actions = audio?.available_actions;
    if (audio?.provider != null && actions != null) {
        return actions.includes(action);
    }
    if (ACTIONS_UNKNOWN_TO_LEGACY_BACKEND.has(action))
        return true;
    return actions == null || actions.includes(action);
}
/**
 * Что можно выбрать в форме видеообложки. `hasCover`: `false` — обложки точно
 * нет, `undefined` — неизвестно (превью не загрузилось), тогда не прячем: решит
 * бэк, а его отказ покажем понятным текстом.
 */
export function videoCoverOptionsAvailability(audio, hasCover) {
    return {
        coverBackground: hasCover !== false,
        withText: isSunoTrack(audio),
    };
}
